'use strict';

var _classCallCheck = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _slicedToArray = require("/var/apps/finb/axis-frontend/axis-fe-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _default = require('react-phone-number-input/locale/default');

var _default2 = _interopRequireDefault(_default);

var _antd = require('antd');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metadataFull = require('libphonenumber-js/metadata.full.json');

var _metadataFull2 = _interopRequireDefault(_metadataFull);

var _libphonenumberJs = require('libphonenumber-js');

var _custom = require('libphonenumber-js/custom');

var _styled = require('./styled');

var _styled2 = _interopRequireDefault(_styled);

var _isSp = require('../../utils/isSp');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Option = _antd.Select.Option;
var toFilterOptions = ['ext', 'ZZ', 'country'];
var countriesOptions = Object.entries(_default2.default).map(function (_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      countryCode = _ref2[0],
      countryName = _ref2[1];

  return {
    value: countryCode,
    label: countryName.replace(/\([^)]*\)/g, '')
  };
}).filter(function (_ref3) {
  var value = _ref3.value;
  return !toFilterOptions.includes(value);
});

var PhoneNumberInput =
/*#__PURE__*/
function (_react$Component) {
  _inherits(PhoneNumberInput, _react$Component);

  function PhoneNumberInput(props) {
    var _this;

    _classCallCheck(this, PhoneNumberInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PhoneNumberInput).call(this, props));
    _this.state = {
      country: undefined,
      countryCode: undefined,
      value: null,
      focused: false,
      hover: false
    };

    _this.getPhoneNumber = function (value, countryCode, country) {
      return value ? {
        countryCode: country,
        number: "+".concat(countryCode).concat(value)
      } : null;
    };

    _this.onCountryChange = function () {
      var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var value = _this.state.value;
      var countryCode = country && (0, _libphonenumberJs.getCountryCallingCode)(country);

      if (countryCode) {
        _this.setState(_extends({}, _this.state, {
          country: country,
          countryCode: countryCode
        }));

        _this.props.onChange(_this.getPhoneNumber(value, countryCode, country));
      }
    };

    _this.onHandleChange = function (value) {
      if (!value) {
        _this.setState({
          country: undefined,
          countryCode: undefined,
          value: null
        });

        _this.props.onChange(null);
      }
    };

    _this.onNumberChange = function (e) {
      var _this$state = _this.state,
          countryCode = _this$state.countryCode,
          country = _this$state.country;
      var parsedPhoneNumber = (0, _custom.parseIncompletePhoneNumber)(e.target.value || '');
      var value = parsedPhoneNumber.replace("+".concat(countryCode), '');

      _this.setState(_extends({}, _this.state, {
        value: value
      }));

      _this.props.onChange(_this.getPhoneNumber(parsedPhoneNumber, countryCode, country));
    };

    _this.onInputFocus = function () {
      _this.setState(_extends({}, _this.state, {
        focused: true
      }));

      _this.props.onFocus();
    };

    _this.onInputBlur = function (e) {
      _this.setState(_extends({}, _this.state, {
        focused: false
      }));

      var _this$state2 = _this.state,
          countryCode = _this$state2.countryCode,
          country = _this$state2.country,
          value = _this$state2.value;
      var parsedPhoneNumber = (0, _custom.parseIncompletePhoneNumber)(value || '');

      _this.props.onBlur(_this.getPhoneNumber(parsedPhoneNumber, countryCode, country));
    };

    _this.onInputMouseEnter = function () {
      _this.setState(_extends({}, _this.state, {
        hover: true
      }));
    };

    _this.onInputMouseLeave = function () {
      _this.setState(_extends({}, _this.state, {
        hover: false
      }));
    };

    _this.filterCountriesList = function () {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var option = arguments.length > 1 ? arguments[1] : undefined;
      return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    var phone = _this.props.value;
    var phoneNumber = phone.countryCode + phone.number;

    if (phone && phone.number && phone.countryCode) {
      var country = countriesOptions.find(function (_ref4) {
        var value = _ref4.value;
        return value === (0, _libphonenumberJs.parseNumber)(phoneNumber, {
          extended: true
        }).country;
      });

      var _ref5 = (0, _libphonenumberJs.parseNumber)(phoneNumber, {
        extended: true
      }),
          countryCode = _ref5.countryCallingCode;

      _this.state = _extends({}, _this.state, {
        country: country ? country.value : null,
        countryCode: countryCode,
        value: phone.number.replace("+".concat(countryCode), '')
      });
    }

    return _this;
  }

  _createClass(PhoneNumberInput, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      var phone = props.value;
      var newState = {};

      if (phone && phone.number && phone.countryCode) {
        var country = countriesOptions.find(function (_ref6) {
          var value = _ref6.value;
          return value === phone.countryCode;
        });

        var _ref7 = (0, _libphonenumberJs.parseNumber)(phone.number, {
          extended: true
        }),
            countryCode = _ref7.countryCallingCode;

        if (countryCode) {
          newState = _extends({}, this.state, {
            country: country.value,
            countryCode: countryCode,
            value: phone.number.replace("+".concat(countryCode), '')
          });
        }
      } else if (!phone) {
        newState = _extends({}, this.state, {
          value: null
        });
      }

      this.setState(function (state) {
        return _extends({
          state: state
        }, newState);
      });
    }
  }, {
    key: "format",
    value: function format(value) {
      var _this$state3 = this.state,
          countryCode = _this$state3.countryCode,
          country = _this$state3.country;

      if (!countryCode) {
        return null;
      }

      return (0, _custom.formatIncompletePhoneNumber)("+".concat(countryCode).concat(value), country, _metadataFull2.default).replace("+".concat(countryCode), '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state4 = this.state,
          value = _this$state4.value,
          countryCode = _this$state4.countryCode,
          country = _this$state4.country,
          focused = _this$state4.focused,
          hover = _this$state4.hover,
          allowClear = _this$state4.allowClear;
      var disabled = this.props.disabled;
      return _react2.default.createElement('div', {
        className: (0, _isSp.isSp)() ? "mask-phone-number-sp ".concat(focused || hover ? 'mask-phone-number-sp__focused' : '') : "mask-phone-number ".concat(focused || hover ? 'mask-phone-number__focused' : '', " ").concat(this.props.className)
      }, _react2.default.createElement(_styled2.default.Select, {
        onChange: this.onHandleChange,
        placeholder: 'Country',
        showSearch: true,
        value: country,
        filterOption: this.filterCountriesList,
        disabled: disabled,
        onSelect: this.onCountryChange,
        allowClear: true
      }, countriesOptions.map(function (country) {
        return _react2.default.createElement(Option, {
          key: country.value,
          value: country.value,
          title: country.label
        }, country.label);
      })), countryCode && _react2.default.createElement('span', {
        className: 'country-code'
      }, '+', countryCode), _react2.default.createElement(_antd.Input, {
        onChange: this.onNumberChange,
        placeholder: this.props.placeholder || '',
        onFocus: this.onInputFocus,
        onBlur: this.onInputBlur,
        value: this.format(value),
        disabled: !countryCode || disabled,
        className: !countryCode && !disabled ? 'temporary-disabled' : '',
        onMouseEnter: this.onInputMouseEnter,
        onMouseLeave: this.onInputMouseLeave
      }));
    }
  }]);

  return PhoneNumberInput;
}(_react.Component);

PhoneNumberInput.defaultProps = {
  country: {},
  number: null,
  disabled: false,
  onChange: function onChange() {},
  onBlur: function onBlur() {},
  onFocus: function onFocus() {}
};
PhoneNumberInput.propTypes = {
  country: _propTypes2.default.object,
  disabled: _propTypes2.default.bool,
  number: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func
};
exports.default = PhoneNumberInput;